import { createClient } from '@supabase/supabase-js';

// CORRECT FULL CREDENTIALS FROM YOUR DASHBOARD
const supabaseUrl = 'https://iunprndypvxttkzjvems.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1bnBybmR5cHZ4dHRrempqdmVtcyIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzI0NDI1NDc5LCJleHAiOjIwMzk5ODU0Nzl9.eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1bnBybmR5cHZ4dHRrempqdmVtcyIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzI0NDI1NDc5LCJleHAiOjIwMzk5ODU0Nzl9.JOuz7ax8wGSumyYWMqnmOvHsn_gpZYuKsUE5ZdA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function updatePaymentStatus(projectId, paymentsMade, status, paymentStatus) {
  try {
    console.log('🔄 Attempting Supabase update for project:', projectId);
    
    // Test connection first
    const { data: testData, error: testError } = await supabase
      .from('projects')
      .select('id')
      .eq('id', projectId)
      .limit(1);
    
    if (testError) {
      console.error('❌ Supabase connection test failed:', testError);
      return { success: false, error: `Connection failed: ${testError.message}` };
    }
    
    if (!testData || testData.length === 0) {
      console.error('❌ Project not found in Supabase:', projectId);
      return { success: false, error: `Project ${projectId} not found in database` };
    }
    
    console.log('✅ Project found, proceeding with update...');
    
    // Perform the update
    const { data, error } = await supabase
      .from('projects')
      .update({
        payments_made: paymentsMade,
        status: status,
        payment_status: paymentStatus,
        last_payment_sync: new Date().toISOString()
      })
      .eq('id', projectId)
      .select();
    
    if (error) {
      console.error('❌ Supabase update error:', error);
      return { success: false, error: error.message };
    }
    
    console.log('✅ Supabase updated successfully:', data);
    return { success: true, data };
    
  } catch (error) {
    console.error('❌ Supabase error:', error);
    return { success: false, error: error.message };
  }
}

// Test function for debugging
export async function testSupabaseConnection() {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .limit(5);
    
    console.log('Supabase test data:', data);
    console.log('Supabase test error:', error);
    
    return { data, error };
  } catch (error) {
    console.error('Connection test failed:', error);
    return { data: null, error };
  }
}